// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ServerGroupPerDatabaseQueryTableQueryVariables = Types.Exact<{
  serverGroupId: Types.Scalars["ID"]["input"];
  datname: Types.Scalars["String"]["input"];
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
  statementTypes:
    | Array<Types.Scalars["String"]["input"]>
    | Types.Scalars["String"]["input"];
  offset?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  limit?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  filter?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  sortBy?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  sortDirection?: Types.InputMaybe<Types.SortDirection>;
  compare?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type ServerGroupPerDatabaseQueryTableQuery = {
  __typename?: "GraphqlQuery";
  getQueryStatsByDatabaseGroup: Array<{
    __typename?: "QuerySummaryStats";
    id: string;
    databaseId: string;
    normalizedQuery: string;
    truncatedQuery: string;
    avgTime: number;
    avgTimeDelta?: number | null;
    callsPerMinute: number;
    callsPerMinuteDelta?: number | null;
    bufferHitRatio?: number | null;
    pctOfTotalIo?: number | null;
    pctOfTotal: number;
    postgresRoleCount: number;
    postgresRole?: {
      __typename?: "PostgresRole";
      id: string;
      name: string;
    } | null;
    server: {
      __typename?: "Server";
      id: string;
      humanId: string;
      name: string;
    };
  }>;
};

export const ServerGroupPerDatabaseQueryTableDocument = gql`
  query ServerGroupPerDatabaseQueryTable(
    $serverGroupId: ID!
    $datname: String!
    $startTs: Int!
    $endTs: Int!
    $statementTypes: [String!]!
    $offset: Int
    $limit: Int
    $filter: String
    $sortBy: String
    $sortDirection: SortDirection
    $compare: Boolean
  ) {
    getQueryStatsByDatabaseGroup(
      serverGroupId: $serverGroupId
      datname: $datname
      startTs: $startTs
      endTs: $endTs
      statementTypes: $statementTypes
      offset: $offset
      limit: $limit
      filter: $filter
      sortBy: $sortBy
      sortDirection: $sortDirection
      compare: $compare
    ) {
      id
      databaseId
      normalizedQuery
      truncatedQuery
      avgTime
      avgTimeDelta
      callsPerMinute
      callsPerMinuteDelta
      bufferHitRatio
      pctOfTotalIo
      pctOfTotal
      postgresRole {
        id
        name
      }
      postgresRoleCount
      server {
        id
        humanId
        name
      }
    }
  }
`;

/**
 * __useServerGroupPerDatabaseQueryTableQuery__
 *
 * To run a query within a React component, call `useServerGroupPerDatabaseQueryTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useServerGroupPerDatabaseQueryTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServerGroupPerDatabaseQueryTableQuery({
 *   variables: {
 *      serverGroupId: // value for 'serverGroupId'
 *      datname: // value for 'datname'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *      statementTypes: // value for 'statementTypes'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      compare: // value for 'compare'
 *   },
 * });
 */
export function useServerGroupPerDatabaseQueryTableQuery(
  baseOptions: Apollo.QueryHookOptions<
    ServerGroupPerDatabaseQueryTableQuery,
    ServerGroupPerDatabaseQueryTableQueryVariables
  > &
    (
      | {
          variables: ServerGroupPerDatabaseQueryTableQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ServerGroupPerDatabaseQueryTableQuery,
    ServerGroupPerDatabaseQueryTableQueryVariables
  >(ServerGroupPerDatabaseQueryTableDocument, options);
}
export function useServerGroupPerDatabaseQueryTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServerGroupPerDatabaseQueryTableQuery,
    ServerGroupPerDatabaseQueryTableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ServerGroupPerDatabaseQueryTableQuery,
    ServerGroupPerDatabaseQueryTableQueryVariables
  >(ServerGroupPerDatabaseQueryTableDocument, options);
}
// @ts-ignore
export function useServerGroupPerDatabaseQueryTableSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ServerGroupPerDatabaseQueryTableQuery,
    ServerGroupPerDatabaseQueryTableQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ServerGroupPerDatabaseQueryTableQuery,
  ServerGroupPerDatabaseQueryTableQueryVariables
>;
export function useServerGroupPerDatabaseQueryTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServerGroupPerDatabaseQueryTableQuery,
        ServerGroupPerDatabaseQueryTableQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ServerGroupPerDatabaseQueryTableQuery | undefined,
  ServerGroupPerDatabaseQueryTableQueryVariables
>;
export function useServerGroupPerDatabaseQueryTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServerGroupPerDatabaseQueryTableQuery,
        ServerGroupPerDatabaseQueryTableQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ServerGroupPerDatabaseQueryTableQuery,
    ServerGroupPerDatabaseQueryTableQueryVariables
  >(ServerGroupPerDatabaseQueryTableDocument, options);
}
export type ServerGroupPerDatabaseQueryTableQueryHookResult = ReturnType<
  typeof useServerGroupPerDatabaseQueryTableQuery
>;
export type ServerGroupPerDatabaseQueryTableLazyQueryHookResult = ReturnType<
  typeof useServerGroupPerDatabaseQueryTableLazyQuery
>;
export type ServerGroupPerDatabaseQueryTableSuspenseQueryHookResult =
  ReturnType<typeof useServerGroupPerDatabaseQueryTableSuspenseQuery>;
export type ServerGroupPerDatabaseQueryTableQueryResult = Apollo.QueryResult<
  ServerGroupPerDatabaseQueryTableQuery,
  ServerGroupPerDatabaseQueryTableQueryVariables
>;
